/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box, Flex, Heading } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@moms/Utility/StructuredTextParser';
import SimpleButton from '@moms/Buttons/SimpleButton';

/* Styles */
import TopBannerV2St from '@moms/styleData/TopBannerV2St';


/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */

const MainLayout = ({ region, lang, sectionContent, sectionId }) => {
  return (
    <Box
      w="100%"
      bgImage={{
        base: sectionContent.mobileImage.url,
        md: sectionId === 'banner-ipl' ? sectionContent.mobileImage.url : sectionContent.desktopImage.url,
        lg: sectionContent.desktopImage.url,
      }}
      bgPos={{
        base: 'top center',
        md: sectionId === 'banner-ipl' ? 'top center' : 'center',
        lg: 'right'
      }}
      bgSize={{
        base: '100% 305px',
        sm: '70% 305px',
        md: sectionId === 'banner-ipl' ? 'auto 305px' : 'cover',
        lg: sectionId === 'banner-ipl' ? 'contain' : 'cover',
      }}
      height={{ base: 'auto', md: sectionId === 'banner-ipl' ? 'auto' : '635', lg: '635' }}
      // maxW={1920}
      bgRepeat="no-repeat"
      maxH={{ base: 'none', md: sectionId === 'banner-ipl' ? 'none' : '640', lg: '640' }}
      maxW={1200}
      mx="auto"
    >
      {/* content flex */}
      <ContentFlex
        region={region}
        lang={lang}
        sectionContent={sectionContent}
        sectionId={sectionId}
      />
    </Box>
  );
};

const ContentFlex = ({ region, lang, sectionContent, sectionId }) => {
  return (
    <Flex
      pt={{ base: '305px', md: '305px', lg: '0' }}
      mb={{ base: '0', md: 'auto' }}
      w={{ base: '100%', md: '60%' }}
      height="100%"
    >
      <Flex
        height="100%"
        flexDir="column"
        bg={{
          // base: '#010102',
          md: 'linear-gradient(88deg, #000 12.55%, rgba(0, 0, 0, 0.78) 49.71%, rgba(0, 0, 0, 0.36) 65.1%, rgba(15, 15, 15, 0.00) 99%)',
        }}
        justifyContent="center"
        mt={{ base: sectionId === 'banner-ipl' ? '0' : '27px', md: '0' }}
        px="16px"
        pb={{ base: '80px', md: '0' }}
        pl={{ base: '16px', md: '10%' }}
      >
        <Heading
          {...TopBannerV2St[lang].heading}
          marginBottom={{ base: sectionId === 'banner-ipl' ? '0' : '1rem' }}
        >
          {sectionContent.title}
        </Heading>
        <StructuredTextParser
          sx={{
            mark: {
              background: {
                base: 'linear-gradient(100deg, #636EFF 0.96%, #EC2224 98.64%)',
                md: 'linear-gradient(270deg, #EC2224 0%, #636EFF 100%)',
              },
              textFillColor: { base: 'transparent', md: 'transparent' },
              backgroundClip: { base: 'text', md: 'text' },
              ...TopBannerV2St[lang].markText,
              fontWeight: sectionId === 'banner-ipl' ? '600' : '500',
              width: { base: sectionId === 'banner-ipl' ? '65%' : '100%', md: '100%'},
              display: 'block'
            },

            p: { ...TopBannerV2St[lang].des } ,
          }}
          // maxW={{ base: '100%', sm: '570px' }}
          w={{ base: '100%', md: '570px' }}
          // -webkit-background-clip: text;
          m={{ base: '0', md:'0', lg:'0' }}
          mt={{ base: '40px', md: sectionId === 'banner-ipl' ? '10px' : '40px', lg:sectionId === 'banner-ipl' ? '10' : '40px' }}
          str={render(sectionContent.quote)}
          color="#fff"
          textAlign="left"
        />
        {sectionId === 'banner-ipl' && (
        <Box display="block" mt={{base:'0px', md:'30px'}} width={{ base: '100%', sm: '350px', lg: '450px' }}>
          <SimpleButton
            mx={{ base: 'auto', sm: '0' }}
            mb="12px"
            height={{ base: '56px', md: '56px' }}
            display={{ base: 'flex' }}
            fontWeight={600}
            borderWidth={'1px'}
            border={'none'}
            borderRadius={'55px'}
            w={{ base: '100%', sm: '350px', lg: '435px' }}
            minW="280px"
            _hover={{ bgColor: '#DBDBDB' }}
            bgColor={'#FFFFFF'}
            mt={{ base: '2.5rem', md: '30px' }}
            style={sectionContent.button[0]}
            region={region}
            lang={lang}
            py="21px"
            textAlign="center"
            alignItems="center"
            justifyContent="center"
          />
        </Box>
      )}
      </Flex>
    </Flex>
  );
};

const TopBannerV2 = ({ region, lang, sectionContent, sectionId }) => {
  return (
    <Box
      w="100%"
      bg="#010102"
      height="100%"
      pt={{ base: '1.5rem', md: '80px' }}
      pos="relative"
      _after={{
        content: "''",
        pos: 'absolute',
        height: '0.6px',
        left: '0',
        right: '0',
        width: '100%',
        bottom: '0',
        zIndex: '1',
        background:
          'radial-gradient(80.14% 21.43% at 50% 50%, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.00) 100%), #010102',
        backdropFilter: 'blur(calc(var(--sds-size-blur-100) / 2))',
        borderTop: '1px solid rgba(255, 255, 255, 0.20)',
      }}
    >
      <MainLayout
        region={region}
        lang={lang}
        sectionContent={sectionContent}
        sectionId={sectionId}
      />
    </Box>
  );
};

export default TopBannerV2;
